import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faL, faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faFileLines } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faXmark, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, CommonAPIConstants, LabBillingConstants, FilesAPIConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, formatDate } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'



const LabBilling = () => {

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Default value for the input is the current date
  const defaultDate = getCurrentDate();
  const defaultFromDate = new Date('2015-01-01');


  const today = new Date();
  const formatCurDate = format(today, 'MM/dd/yyyy');

  const [isHideChecked, setIsHideChecked] = useState(false);
  const [updatedTabledata, setUpdatedTableData] = useState([]);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(formatCurDate); // State to store start date
  const [endDate, setEndDate] = useState(formatCurDate);     // State to store end date
  const [loading, setLoading] = useState(true);

  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState('0');
  const [selectedCMS33b, setSelectedCMS33b] = useState('0');
  const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
  const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
  const [selectedSearchFilter, setSelectedSearchFilter] = useState('0');
  const [selectedLocation, setSelectedLocation] = useState('0');
  const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('0');
  const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
  const [selectedServiceLocation, setSelectedServicelocation] = useState('81');
  const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [selectedProviderSuggestion, setSelectedProviderSuggestion] = useState([]);
  const [selectedCPTSuggestion, setSelectedCPTSuggestion] = useState(null);

  const [locations, setLocations] = useState([]);
  const [locations2, setLocations2] = useState([]);
  const [selectedLocations2, setselectedLocations2] = useState('-1');
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);
  const [selectClearinghouse, setSelectClearingHouse] = useState([]);
  const [allSelectedClearinghouse, setAllSelectedClearingHouse] = useState([]);
  const [BillingNPIs, setBillingNPIs] = useState([]);
  const [rows, setRows] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [selectedInsValue, setselectedInsValue] = useState('');
  const [searchPatientText, setSearchPatientText] = useState('');
  const [searchProvidersText, setSearchProvidersText] = useState('');
  const [searchInsuranceText, setSearchInsuranceText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
  const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
  const [sPatID, setSPatID] = useState('');
  const [sClaimStatus, setsClaimStatus] = useState('');
  const [rowsValidation, setRowsValidation] = useState('');
  const [isChecked, setIsChecked] = useState(0);

  const userData = useSelector((state) => state.user.user);
  const baseUrl = useSelector((state) => state.user.baseUrl);

  const [tableDetails, setTableDetails] = useState([]);
  const [tableInsDetails, setTableInsDetails] = useState([]);
  const [checkEligibility, setCheckEligibility] = useState([]);
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [selectAllDropDown, setSelectAllDropDown] = useState([]);
  const [checkboxes, setCheckboxes] = useState();

  const [searchPatientData, setSearchPatientData] = useState([]);
  const [suggestionProviders, setSuggestionProviders] = useState('');
  const [suggestionInsurance, setSuggestionInsurance] = useState('');
  const [patientList, setPatientList] = useState('');




  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
  const [UnitChargeRows, setUnitChargeRows] = useState([]);
  const [unitCheckbox, setUnitCheckbox] = useState([]);
  const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
  const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
  const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
  const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
  const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
  const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
  const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
  const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
  const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
  const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
  const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);
  const [filteredData, setFilteredData] = useState([]);
  const [providerDataList, setProviderDataList] = useState([]);
  const [cptDataList, setCptDataList] = useState([]);
  const [modDataList, setModDataList] = useState([]);
  const [mod2DataList, setMod2DataList] = useState([]);
  const [mod3DataList, setMod3DataList] = useState([]);
  const [diag1DataList, setDiag1DataList] = useState([]);
  const [diag2DataList, setDiag2DataList] = useState([]);
  const [diag3DataList, setDiag3DataList] = useState([]);
  const [diag4DataList, setDiag4DataList] = useState([]);
  const [selectedInsRows, setSelectedInsRows] = useState([]);
  const [selectedCPTCode, setSelectedCPTCode] = useState([]);
  const [selectedCPTPatientID, setSelectedCPTPatientID] = useState([]);
  const [selectedPatientID, setSelectedPatientID] = useState([]);
  const [selectedDiag1ID, setSelectedDiag1ID] = useState([]);
  const [selectedDiag2ID, setSelectedDiag2ID] = useState([]);
  const [selectedDiag3ID, setSelectedDiag3ID] = useState([]);
  const [selectedDiag4ID, setSelectedDiag4ID] = useState([]);
  const [newRows, setNewRows] = useState([]);
  const [selectedLabValue, setSelectedLabValue] = useState('4');

  const [searchByPatient, setSearchByPatient] = useState('');
  const [searchByDOB, setSearchByDOB] = useState('');
  const [searchByInsuranceID, setSearchByInsuranceID] = useState('');
  const [searchByProvider, setSearchByProvider] = useState('');
  const [searchByCPT, setSearchByCPT] = useState('');
  const [searchByCPT2, setSearchByCPT2] = useState('');
  const [searchByMod1, setSearchByMod1] = useState('');
  const [searchByMod2, setSearchByMod2] = useState('');
  const [searchByMod3, setSearchByMod3] = useState('');
  const [searchByICD1, setSearchByICD1] = useState('');
  const [searchByICD2, setSearchByICD2] = useState('');
  const [searchByICD3, setSearchByICD3] = useState('');
  const [searchByICD4, setSearchByICD4] = useState('');
  const [searchByDOS, setSearchByDOS] = useState('');
  const [searchByLocation, setSearchByLocation] = useState('');


  const [selectedProviderText, setSelectedProviderText] = useState('');
  const [selectedCPTList, setSelectedCPTList] = useState('');
  const [selectedModList, setSelectedModList] = useState('');
  const [selectedMod2Value, setSelectedMod2Value] = useState('');
  const [selectedMod3Value, setSelectedMod3Value] = useState('');
  const [selectedDiag1Value, setSelectedDiag1Value] = useState('');
  const [selectedDiag2Value, setSelectedDiag2Value] = useState('');
  const [selectedDiag3Value, setSelectedDiag3Value] = useState('');
  const [selectedDiag4Value, setSelectedDiag4Value] = useState('');
  const [selectedUnitValue, setSelectedUnitValue] = useState('');
  const [selectedUnitChargeValue, setSelectedUnitChargeValue] = useState('');
  const [searchByCodes, setSearchByCodes] = useState('');
  const [searchByCaseID, setSearchByCaseID] = useState('');
  const [searchByPolicy, setSearchByPolicy] = useState('');

  const [selectedTextField, setSelectedTextField] = useState('');
  const [selectedValueField, setSelectedValueField] = useState('');
  const [labDropDownData, setLabDropDownData] = useState([]);


  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showDownLoadErrorModal, setShowDownLoadErrorModal] = useState(false);
  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [closeClaimsModal, setCloseClaimsModal] = useState(false);
  const [showFaxModal, setShowFaxModal] = useState(false);
  const [savedRowCount, setSavedRowCount] = useState(0);
  const [deleteRowCount, setDeleteRowCount] = useState(0);
  const [successTimer, setSuccessTimer] = useState(15000);
  const [buttonClicked, setButtonClicked] = useState([]);
  const [showIcon, setShowIcon] = useState(true);
  const [showFaxError, setShowFaxError] = useState(false);
  const [showFaxSaveMsg, setShowFaxSaveMsg] = useState(false);
  const [sortingOrder, setSortingOrder] = useState('asc');
  const [tableData, setTableData] = useState([]);

  const [sortDosDate, setSortDosDate] = useState('asc');

  const [sortDateOrder, setSortDateOrder] = useState('asc');
  const [sortedDateData, setSortedDateData] = useState([]);

  const [sortByInsurance, setSortByInsurance] = useState(false);
  const [sortedInsData, setSortedInsData] = useState([]);

  const [sortPolicyNumber, setSortPolicyNumber] = useState('asc');
  const [sortOrderCodes, setSortOrderCodes] = useState('asc');
  const [sortCPTCode1, setSortCPTCode1] = useState('asc');
  const [sortCPTCode2, setSortCPTCode2] = useState('asc');
  const [sortICDNumber, setSortICDNumber] = useState('asc');
  const [sortCaseID, setSortCaseID] = useState('asc');
  const [sortProviderName, setSortProviderName] = useState('asc');

  const [activeRow, setActiveRow] = useState(null);

  // const [selectedRequisitionRows, setSelectedRequisitionRows] = useState([]);
  const [omitboxRows, setomitboxRows] = useState(
{}
  );
  // const [cpt1Rows, setcpt1Rows] = useState([]);
  // const [cpt2Rows, setcpt2Rows] = useState([]);
  const [practiceTaxonomycodes, setPracticeTaxonomycodes] = useState([]);


  const [locationNPIError, setLocationNPIError] = useState('');
  const [providerNPIError, setProviderNPIError] = useState('');
  const [taxonomyCodeError, setTaxonomyCodeError] = useState('');
  const [locationError, setLocationError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedInsurances, setSelectedInsurances] = useState({});
  const [selectedPolicyNumbers, setSelectedPolicyNumbers] = useState({});
  const [policyNumbers, setPolicyNumbers] = useState({});
  const [selectedModifier, setselectedModifier] = useState('SA');
  const [showDataModal, setShowDataModal] = useState(false);

  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [selectedData, setSelectedData] = useState('');

  const [hasFetched, setHasFetched] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isLocChecked, setIsLocChecked] = useState(false);
  const [generateClaimClicked, setGenerateClaimClicked] = useState(false);
const [rowSelections, setRowSelections] = useState({});
  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;
  var LocationId = userData ? userData.LocationID : null;

  const sAuthToken = useSelector((state) => state.user.token);



  const rowsPerPage = 200;
  const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);



  const loadMoreRecords = useCallback(() => {
    setVisibleRecords((prev) => {
      const next = Math.min(prev + rowsPerPage, filteredTableDetails.length);


      if (next > prev) {
        setPopupMessage(`${next} records out of ${filteredTableDetails.length} loaded`);
        setShowPopup(true);


        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }

      return next;
    });
  }, [filteredTableDetails.length]);




  const handleScroll = useCallback(() => {
    const isAtBottom =
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

    if (isAtBottom) {
      loadMoreRecords();
    }
  }, [loadMoreRecords]);




  useEffect(() => {
    setVisibleRecords(rowsPerPage);
  }, [filteredTableDetails]);




  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);







  useEffect(() => {


    handleTableDataClick();


  }, []);



  useEffect(() => {
    if (!hasFetched && startDate && endDate) {

      handleTableDataClick();
      setHasFetched(true);
    }
  }, [startDate, endDate, hasFetched]);




  useEffect(() => {
    document.title = 'Lab Billing'


    let timerId;

    if (showSuccessModal || deleteSuccessModal) {
      // Start the timer when the success modal is shown
      timerId = setTimeout(() => {
        setShowSuccessModal(false);
        setDeleteSuccessModal(false);
      }, successTimer);
    }


    return () => {
      clearTimeout(timerId);
    };
  }, [showSuccessModal, successTimer, deleteSuccessModal]);
















  const handleStartDateChange = (date) => {
    if (date) {
      const formatDate = format(date, 'MM/dd/yyyy')

      setStartDate(formatDate);
      setEndDate(formatDate);
      setIsStartOpen(false)

    } else {
      setStartDate(null);
    }
  };




  const handleEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);

      setIsEndOpen(false)


    } else {
      setEndDate(null);
    }
  };






  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };









  const handleStartDoneClick = () => {
    setIsStartOpen(false);
  };









  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);
      setEndDate(today);
      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
  };



  const CalendarContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
          Today
        </button>

      </div>
    </div>
  );


  const CalendarStartContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
          Today
        </button>

      </div>
    </div>
  );





  const handleHideCheckboxChange = () => {
    setIsHideChecked(!isHideChecked);

    if (isHideChecked) {
      // Reset to original dates
      setStartDate(defaultDate);
      setEndDate(defaultDate);
    } else {
      // Set FROM date to 1/1/2015 and TO date to the current date
      setStartDate('2015-01-01');
      setEndDate(defaultDate);
    }
  };




  // Api Integration of all Dropdowns

  useEffect(() => {




    var inputStruct = {

      LoggedInUserDetails: userData

    }

    var myInput = { sInputJSON: JSON.stringify(userData) };


    myInput = JSON.stringify(myInput);

    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInput
    })


      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data.d);
        const dropdownData = parsedData.Data;
        setSelectAllDropDown(dropdownData);

        // Populate the dropdowns with the received data
        setLocations(dropdownData.LocationDetails)
        setLocations2(dropdownData.LocationDetails)
        setCMS33aData(dropdownData.CMSbox33aData);
        setCMS33bData(dropdownData.CMSbox33bData);
        setBillingNPIs(dropdownData.PracticeBillingNPIs);
        setServiceLocations(dropdownData.ServiceLocation);
        setPracticeProvider(dropdownData.PracticeProviders);
        setProviderCategory(dropdownData.ProvidersCategories);
        setSearchFilterData(dropdownData.SearchByFilters);
        setStatusRadioButton(dropdownData.StatusRadioButtons);
        setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
        setPracticeTaxonomycodes(dropdownData.PracticeTaxonomycodes);
        setLoading(false);
      })

      .catch((error) => {
        console.error('Error fetching data: ', error);
      });

  }, [])




  useEffect(() => {

    setIsTextBoxDisabled(selectedSearchFilter === '');


    setSearchText('');


  }, [selectedSearchFilter]);





  useEffect(() => {



    if (selectedSearchFilter === 'Pat' && searchText) {
      fetchPatientNames();
    } else if (selectedSearchFilter === 'Provider' && searchText) {
      fetchProviders();
    } else if (selectedSearchFilter === 'Insurance' && searchText) {
      fetchInsuranceCompanies();
    }
  }, [selectedSearchFilter, searchText]);





  useEffect(() => {
    // Reset values when showFaxDialog is true
    if (showFaxModal) {
      setRows([]);
      resetDialogValues();
    }
  }, [showFaxModal]);



  const resetDialogValues = () => {
    // startDate('');
    setSelectedProviderText('');
    setSelectedCPTList('');
    setSelectedModList(null);
    setSelectedUnitValue('');
    setSelectedUnitChargeValue('');
    setSelectedDiag1Value('');
    setSelectedDiag2Value('');
    setSelectedDiag3Value('');
    setSelectedDiag4Value('');
    setSelectedMod2Value('');
    setSelectedMod3Value('');
  };





  const handleSuggestionSelect = (item) => {

    setSearchText(item.label);
    setSuggestions([]);

    setSPatID(item.val);

  };





  const fetchPatientNames = () => {



    var inputStruct = {

      "sPatName": searchText,
      "sPracticeID": userPracticeID,
      "sLocationID": LocationId

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliPatientNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const patientData = parsedData.Data

        if (Array.isArray(patientData)) {
          setSuggestions
            (patientData.map((item) => ({
              label: (item.split('$')[0]).split('|')[1].trim(),
              val: item.split('$')[1].trim(),
            })));

        } else {


          setSuggestions([]);

          setIsTextBoxDisabled(false);
        }

        setSearchPatientData(suggestions);

      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };




  const fetchSuggestionPatientNames = () => {


    if (!setSearchPatientText) {
      setSearchPatientData([]);
      return;
    }

    var inputStruct = {

      "sPatName": searchPatientText,
      "sPracticeID": userPracticeID,
      "sLocationID": LocationId

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliPatientNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const patientData = parsedData.Data

        if (Array.isArray(patientData)) {
          // Filter suggestions based on the label
          const filteredSuggestions = patientData
            .filter(item => item.toLowerCase().includes(searchPatientText.toLowerCase()))
            .map(item => ({
              label: (item.split('$')[0]).split('|')[1].replace(',', '').trim(),
              val: item.split('$')[1].trim(),
            }))
            .filter(item => item.label !== selectedSuggestion && item.label !== '');




          const patientID = patientData.val;

          setSearchPatientData(filteredSuggestions);
          setSelectedCPTPatientID(filteredSuggestions.val);


        } else {


          setSearchPatientData([]);


        }


      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };


  const isMounted = useRef(true);

  useEffect(() => {

    if (isMounted.current) {
      isMounted.current = false;
    } else {
      fetchSuggestionPatientNames(searchPatientText);
    }
  }, [searchPatientText]);






  const handlePatientSuggestion = (suggestion) => {

    setSearchPatientText(`${suggestion.label}`);
    setSelectedSuggestion(suggestion.label);
    setSelectedCPTPatientID(suggestion.val);
    setSearchPatientData([]);
    setShowFaxModal(true);
    setSelectedPatientID(suggestion.val)


  };


  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (searchPatientText === '' && searchPatientData.length > 0) {

        setSearchPatientData([]);


      } else {

        fetchSuggestionPatientNames(searchPatientText.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }


  const fetchProviders = () => {

    var inputStruct = {

      "sProviderName": searchText,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data


        if (Array.isArray(providersData)) {
          setSuggestions(providersData.map((item) => ({
            label: (item.split('$')[0]).split('|')[1].trim(),
            val: item.split('$')[1].trim(),
          })));
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });



  };





  const fetchSearchProviders = () => {

    if (!searchProvidersText) {
      // If searchText is empty, you may want to reset or clear any existing data
      setSearchPatientData([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct = {

      "sProviderName": searchText,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data


        if (Array.isArray(providersData)) {
          setSuggestionProviders(providersData.map((item) => ({
            label: (item.split('$')[0]).split('|')[1].trim(),
            val: item.split('$')[1].trim(),
          })));
        } else {
          setSuggestionProviders([]);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });
  };



  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchSearchProviders(searchProvidersText);
  }, [searchProvidersText]);

  const handleProviderSuggestion = (suggestion) => {
    setSearchProvidersText(suggestion.label);
    setSuggestionProviders([]);


  };


  const handleProviderKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (searchProvidersText === '' && suggestionProviders.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setSuggestionProviders([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProviders(searchProvidersText.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }






  const fetchInsuranceCompanies = () => {

    var inputJSON = {

      SearchKey: searchText,

    }

    var sJSONInput = JSON.stringify(inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        const InsuranceData = parsedData.Data



        if (Array.isArray(InsuranceData)) {

          const filteredSuggestions = InsuranceData

            .map(item => ({
              label: item.Insurance,
              val: item.InsuID,
            }))


          const filteredData = filteredSuggestions.filter(ins =>
            ins.label.toLowerCase().includes(searchText.toLowerCase())
          );

          setSuggestions(filteredData);

        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }



        setIsTextBoxDisabled(false);
      })

      .catch((error) => {
        console.error('Error fetching Insurance names:', error);

      });

    return [];

  };







  const handleInputChange = (e) => {
    const inputText = e.target.value;
    setSearchText(inputText);

    if (inputText.length > 0) {
      fetchInsuranceCompanies(inputText);
    } else {
      setSuggestions([]);
    }
  };





  const handleInsSuggestionList = (suggestion) => {
    setSearchText(`${suggestion.label}`);
    setselectedInsValue(`${suggestion.val}`);


    setSuggestions([]);
    setSelectedSuggestion(suggestion.label);
  };


  const handleInsListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (searchText === '') {
        // If input is empty and there are suggestions, remove the entire list
        setSuggestions([]);


      } else {
        const newSearchText = searchText.slice(0, -1);
        fetchInsuranceCompanies(newSearchText);

      }
    }
  }








  // Fetch Providers List for Dialogbox


  const fetchSearchProvidersList = () => {

    if (!selectedProviderText) {
      setProviderDataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {

      "sProviderName": selectedProviderText,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data

        console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


        if (Array.isArray(providersData)) {
          // Correct the structure of filteredProviders
          const filteredProviders = providersData
            .filter(item => item.toLowerCase().includes(selectedProviderText.toLowerCase()))
            .map((item) => ({
              label: (item.split('$')[0]).split('|')[1].trim(),
              id: item.split('$')[1].trim(),
            }))
            .filter(item => item.label !== selectedProviderSuggestion.label);

          setProviderDataList(filteredProviders);
        } else {
          setProviderDataList([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);
      });
  };


  const isProviderMounted = useRef(true);

  useEffect(() => {

    if (isProviderMounted.current) {
      isProviderMounted.current = false;
    } else {
      fetchSearchProvidersList(selectedProviderText);
    }
  }, [selectedProviderText]);




  const handleProviderSuggestionList = (suggestion) => {
    setSelectedProviderText(`${suggestion.label}`);
    setSelectedProviderSuggestion(`${suggestion.id}`);
    setProviderDataList([]);
    setSelectedPatientID(selectedPatientID)



  };


  const handleProviderListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedProviderText === '' && providerDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setProviderDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProvidersList(selectedProviderText.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }




  //Fetch CPT List

  const fetchSearchCPTList = () => {

    if (!selectedCPTList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setCptDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      cptCode: selectedCPTList
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const cptData = parsedData.Data

        const filteredCPTData = cptData.filter(item =>
          `${item.CPT_Code} ${item.CPTDescription}` !== selectedCPTList
        );

        setCptDataList(filteredCPTData);


      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);

      });
  };



  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchSearchCPTList(selectedCPTList);
  }, [selectedCPTList]);

  const handleSearchCPTList = (suggestion) => {
    setSelectedCPTList(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
    setSelectedCPTCode(`${suggestion.CPT_Code}`);
    setCptDataList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
    setSelectedUnitChargeValue(billingFee);


  };


  const handleCPTListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedCPTList === '' && cptDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchCPTList(selectedCPTList.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }

  //Fetch Mod1 List

  const fetchModList = () => {

    if (!selectedModList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setModDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedModList
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        if (Array.isArray(modData)) {
          setModDataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setModDataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchModList(selectedModList);
  }, [selectedModList]);

  const handleModList = (suggestion) => {
    setSelectedModList(suggestion);


  };


  const handleModListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedModList === '' && modDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setModDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchModList(selectedModList.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch Mod2 SuggestionList



  const fetchMod2List = () => {

    if (!selectedMod2Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedMod2Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        if (Array.isArray(modData)) {
          setMod2DataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod2DataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod2List(selectedMod2Value);
  }, [selectedMod2Value]);

  const handleMod2List = (suggestion) => {
    setSelectedMod2Value(suggestion);
    //setMod2DataList([]);


  };


  const handleMod2ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod2Value === '' && mod2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2List(selectedMod2Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch Mod3 SuggestionList

  const fetchMod3List = () => {

    if (!selectedMod3Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedMod3Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data



        if (Array.isArray(modData)) {
          setMod3DataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod3DataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod3List(selectedMod3Value);
  }, [selectedMod3Value]);

  const handleMod3List = (suggestion) => {
    setSelectedMod3Value(suggestion);
    // setMod3DataList([]);


  };


  const handleMod3ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod3Value === '' && mod3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3List(selectedMod3Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch ICD Suggestion List                                                         

  const fetchDiag1List = () => {

    if (!selectedDiag1Value) {

      setDiag1DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag1Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        setDiag1DataList(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag1List(selectedDiag1Value);
  }, [selectedDiag1Value]);

  const handleDiag1List = (suggestion) => {
    setSelectedDiag1Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)

  }


  const handleDiag1ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag1Value === '' && diag1DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1List(selectedDiag1Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }







  //Fetch ICD2 Suggestion List

  const fetchDiag2List = () => {

    if (!selectedDiag2Value) {

      setDiag2DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag2Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data

        setDiag2DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag2List(selectedDiag2Value);
  }, [selectedDiag2Value]);

  const handleDiag2List = (suggestion) => {
    setSelectedDiag2Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag2ID(diagID)

  };


  const handleDiag2ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag2Value === '' && diag2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1List(selectedDiag2Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch ICD3 Suggestion List
  const fetchDiag3List = () => {

    if (!selectedDiag3Value) {

      setDiag3DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag3Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        setDiag3DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag3List(selectedDiag3Value);
  }, [selectedDiag3Value]);

  const handleDiag3List = (suggestion) => {
    setSelectedDiag3Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag3ID(diagID)

  };


  const handleDiag3ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag3Value === '' && diag3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3List(selectedDiag3Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  const fetchDiag4List = () => {

    if (!selectedDiag4Value) {

      setDiag4DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag4Value
    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

        setDiag4DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag4List(selectedDiag4Value);
  }, [selectedDiag4Value]);

  const handleDiag4List = (suggestion) => {
    setSelectedDiag4Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag4ID(diagID)

  };


  const handleDiag4ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag4Value === '' && diag4DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4List(selectedDiag4Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }




  const handleSelectBillingNPI = (event) => {
    const selectedValue = event.target.value;
    setSelectedBillingNPI(selectedValue);

  }


  const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

  const handleSelectFilterProviders = (event) => {
    const selectedValue = event.target.value;
    setSelectedFilterProvider(selectedValue);

  }



  const [selectedProvider, setSelectedProvider] = useState('');
  const [tdata, setTdata] = useState('');





  // Function to handle checkbox change
  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? 1 : 0;
    setIsChecked(value);
  };




  useEffect(() => {

    setSelectedCheckedRadioButton('0');
    setSelectedStatusRadioButton('0');
  }, []); // Empty dependency array means this effect runs once when the component mounts

  const handleRadioChange = (e) => {
    setSelectedCheckedRadioButton(e.target.value);
  };






  const handleClaimStatusChange = (e) => {

    setSelectedStatusRadioButton(e.target.value);
    const selectedValue = e.target.value;
    setsClaimStatus(selectedValue);

  }



  const processTableData = () => {
    tableDetails.forEach((item) => {

      setRowsValidation(item.DataValidationMessage);
    });
  };


  //All clearingHouse Data


  const handleAllClearingHouse = () => {



    var inputStruct = {


      "sPracticeID": userPracticeID,

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetAllclearingHouse, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetAllclearingHouse, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const allClearingHouseData = parsedData.Data

        setSelectClearingHouse(allClearingHouseData);



      })
      .catch((error) => {
        console.error('Error fetching All clearing house:', error);
      });
  };




  useEffect(() => {

    handleAllClearingHouse();
  }, []);


  const handleLocationChange = (e) => {
    const selectedLocationId = e.target.value;
    setselectedLocations2(selectedLocationId);
  };







  //fetch the data from Lab Dropdown

  useEffect(() => {





    const response = fetch(APIConstants.BASE_URL + LabBillingConstants.GetLabDropDown, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },


    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const LabData = parsedData.Data

        setLabDropDownData(LabData)



      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });

  }, [])




  //Bind the table details



  const handleTableDataClick = (e, DataValidationMessage) => {
    setLoading(true);

    setIsLocChecked('')
    // setcpt1Rows('')
    // setcpt2Rows('')
    // setSelectedRequisitionRows('')
    setRowSelections({})
    var MissingData = DataValidationMessage;

    if (MissingData != "") {
      console.log("Datavalid", MissingData);
    }




    // e.preventDefault();

    var inputStruct = {

      iPracticeID: userPracticeID,
      sFromDate: startDate,
      sToDate: endDate,
      bIsCheckedIn: isChecked,
      sInsuranceID: selectedInsValue,
      sLocationID: selectedLocation,


    };


    var objClaim = {
      'ObjClaims': inputStruct
    }


    var myInput = JSON.stringify(objClaim);
    console.log("input of" + LabBillingConstants.GetLabBillingTable, myInput);



    const url = `${APIConstants.BASE_URL_BILLING}${LabBillingConstants.GetLabBillingTable}?sInputJSON=${myInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {



        const parsedTableData = JSON.parse(data);


        const tableData = parsedTableData.OrderDetails

        setTableDetails(tableData);
        console.log("tableData of" + LabBillingConstants.GetLabBillingTable, parsedTableData);


        setTimeout(() => {
          setLoading(false);
          setFilteredTableDetails(tableData);
        }, 10);




        const tableInsData = parsedTableData.PatInsDetails


        console.log("tableInsData" + LabBillingConstants.GetLabBillingTable, tableInsData);


        setTableInsDetails(tableInsData);



      })

      .catch((error) => {
        setError('API request failed');
        setLoading(false);
      })



  }

const handleSelectAllCPT1 = () => {
  const allSelected = filteredTableDetails.every(
    row => rowSelections[row.IntelliLabDetailsID]?.cpt1
  );

  const newState = {};

  filteredTableDetails.forEach(row => {
    const id = row.IntelliLabDetailsID;
    const prev = rowSelections[id] || {};
    const newCPT1 = !allSelected;
    const CPT2 = prev.cpt2 || false;
    newState[id] = {
      ...prev,
      cpt1: newCPT1,
      selected: newCPT1 || CPT2,
    };
  });

  setRowSelections(newState);
};

const handleSelectAllCPT2 = () => {
  const allSelected = filteredTableDetails.every(
    row => rowSelections[row.IntelliLabDetailsID]?.cpt2
  );

  const newState = {};

  filteredTableDetails.forEach(row => {
    const id = row.IntelliLabDetailsID;
    const prev = rowSelections[id] || {};
    const newCPT2 = !allSelected;
    const CPT1 = prev.cpt1 || false;
    newState[id] = {
      ...prev,
      cpt2: newCPT2,
      selected: newCPT2 || CPT1,
    };
  });

  setRowSelections(newState);
};



const handleSelectOmitBOXAllChange = () => {
  const allSelected = filteredTableDetails.every(
    (item) => omitboxRows[item.IntelliLabDetailsID] === 1
  );
  let updated = { ...omitboxRows };
  filteredTableDetails.forEach((item) => {
    updated[item.IntelliLabDetailsID] = allSelected ? 0 : 1;
  });
  setomitboxRows(updated);
};
const handleOmitBoxRowCheckboxChange = (id) => {
  setomitboxRows((prev) => ({
    ...prev,
    [id]: prev[id] === 1 ? 0 : 1,
  }));
};


  // change the header dropdown for service

  const handleSelectChange = (e, index) => {
    const { value } = e.target;
    setSelectedServicelocation(value);

    // Update dropdown values for selected rows
    setServiceLocations((prevServiceLocations) => {
      const updatedServiceLocations = prevServiceLocations.map((item, index) => {
        if (selectedLocationRows.includes(index)) {

          // If the checkbox is checked for this row, update the dropdown value
          return { ...item, ValueField: value };
        }
        return item;
      });
      return updatedServiceLocations;
    });


    // loop for table rows which will check if the checkbox of servicelocation column is checked then changed the value of servicelocation
    //dropdown as per the value of header dropdown
  };


  const handleTextFieldChange = (e, index) => {
    const { value } = e.target;
    setServiceLocations((prevServiceLocations) => {
      const updatedServiceLocations = prevServiceLocations.map((item, i) => {
        if (i === index) {
          return { ...item, ValueField: value };
        }
        return item;
      });
      return updatedServiceLocations;
    });
  };





// const handleCPTCode1AllChange = () => {
//   const allSelected = tableDetails.every((_, index) => cpt1Rows.includes(index));

//   if (allSelected) {
    
//     const updatedCPT1 = [];
//     setcpt1Rows(updatedCPT1);

    
//     if (cpt2Rows.length == 0) {
//       setSelectedRequisitionRows([]);
//     }
//   } else {
    
//     const allRowIndexes = Array.from({ length: tableDetails.length }, (_, index) => index);
//     setcpt1Rows(allRowIndexes);
//     setSelectedRequisitionRows(allRowIndexes); 
//   }
// };


  // const handleCpt1RowCheckbox = (index) => {
  //   const isChecked = cpt1Rows.includes(index);

  //   const updatedCpt1Rows = isChecked
  //     ? cpt1Rows.filter((selectedRow) => selectedRow !== index)
  //     : [...cpt1Rows, index];

  //   setcpt1Rows(updatedCpt1Rows);

  //   const stillCheckedInCpt2 = cpt2Rows.includes(index);
  //   const shouldKeepSelected = !isChecked && !selectedRequisitionRows.includes(index);

  //   if (!isChecked && shouldKeepSelected) {
  //     setSelectedRequisitionRows([...selectedRequisitionRows, index]);
  //   } else if (isChecked && !stillCheckedInCpt2) {
  //     setSelectedRequisitionRows(selectedRequisitionRows.filter((row) => row !== index));
  //   }
  // };



 

  
// const handleCPTCode2AllChange = () => {
//   const allSelected = tableDetails.every((_, index) => cpt2Rows.includes(index));

//   if (allSelected) {
    
//     const updatedCPT2 = [];
//     setcpt2Rows(updatedCPT2);

  
//     if (cpt1Rows.length == 0) {
//       setSelectedRequisitionRows([]);
//     }
//   } else {
   
//     const allRowIndexes = Array.from({ length: tableDetails.length }, (_, index) => index);
//     setcpt2Rows(allRowIndexes);
//     setSelectedRequisitionRows(allRowIndexes); 
//   }
// };




  // const handleCpt2RowCheckbox = (index) => {
  //   const isChecked = cpt2Rows.includes(index);

  //   const updatedCpt2Rows = isChecked
  //     ? cpt2Rows.filter((selectedRow) => selectedRow !== index)
  //     : [...cpt2Rows, index];

  //   setcpt2Rows(updatedCpt2Rows);

  //   const stillCheckedInCpt1 = cpt1Rows.includes(index);
  //   const shouldKeepSelected = !isChecked && !selectedRequisitionRows.includes(index);

  //   if (!isChecked && shouldKeepSelected) {
  //     setSelectedRequisitionRows([...selectedRequisitionRows, index]);
  //   } else if (isChecked && !stillCheckedInCpt1) {
  //     setSelectedRequisitionRows(selectedRequisitionRows.filter((row) => row !== index));
  //   }
  // };




  // const handleSelectInsuranceAllChange = () => {
  //   const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

  //   if (allSelected) {
  //     // Deselect all checkboxes
  //     setInsuranceAllCheckbox([]);
  //     handleSelectAllChange([]);
  //   } else {
  //     // Select all checkboxes
  //     setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

  //     handleSelectAllChange();


  //   }
  // };


  // const handleInsuranceRowCheckbox = (index) => {
  //   if (insuranceAllCheckbox.includes(index)) {
  //     // If the row is already selected, unselect it
  //     setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
  //     setSelectedInsRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
  //   } else {
  //     // If the row is not selected, select it
  //     setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);
  //     setSelectedInsRows((prevSelectedRows) => [...prevSelectedRows, index]);
  //   }
  // };



  // useEffect(() => {

  // }, [insuranceAllCheckbox]);











  // const handleCloseClaimModal = () => {

  //   setCloseClaimsModal(true);

  // }




  const handleCloseModals = () => {
    // Close all modals
    setShowSelectErrorModal(false);
    setShowConfirmSaveModal(false);
    setShowSuccessModal(false);
    setShowDeleteModal(false);
    setShowApprovalSaveModal(false);
    setCloseClaimsModal(false);
    setShowFaxModal(false);
    setShowDataModal(false)
    setShowDownLoadErrorModal(false);
  };


  // const handleOpenDeleteModal = () => {
  //   if (selectedRows.length === 0) {


  //     setShowSelectErrorModal(true);
  //   } else {


  //     setShowDeleteModal(true);
  //   }
  // };



  const locationRef = useRef(null);
  const locationNPIRef = useRef(null);
  const providerNPIRef = useRef(null);
  const taxonomyRef = useRef(null);



const getRowByID = (id) => {
  return filteredTableDetails.find(
    (item) => item.IntelliLabDetailsID === Number(id)
  );
};
const getFilteredInsDetailsForItem = (item) => {
  if (!item || !tableInsDetails) return [];

  const apptDate = new Date(item.Appointment_Date);

  return tableInsDetails.filter(ins =>
    ins.PatientID === item.PatientID &&
    new Date(ins.InsStartDate) <= apptDate &&
    new Date(ins.InsEndDate) >= apptDate
  );
};


const toggleRow = (id) => {
  setRowSelections((prev) => {
    const row = prev[id] || {};
    return {
      ...prev,
      [id]: {
        selected: !row.selected,
        cpt1: row.cpt1 || false,
        cpt2: row.cpt2 || false,
      },
    };
  });
};

const toggleCPT1 = (id) => {
  setRowSelections((prev) => {
    const prevRow = prev[id] || {};
    const newCPT1 = !prevRow.cpt1;
    const CPT2 = prevRow.cpt2 || false;
    const shouldSelect = newCPT1 || CPT2;
    return {
      ...prev,
      [id]: {
        ...prevRow,
        selected: shouldSelect,
        cpt1: newCPT1,
      },
    };
  });
};

const toggleCPT2 = (id) => {
  setRowSelections((prev) => {
    const prevRow = prev[id] || {};
    const newCPT2 = !prevRow.cpt2;
    const CPT1 = prevRow.cpt1 || false;
    const shouldSelect = newCPT2 || CPT1;
    return {
      ...prev,
      [id]: {
        ...prevRow,
        selected: shouldSelect,
        cpt2: newCPT2,
      },
    };
  });
};

const handleSelectAllRows = () => {
  const allSelected = filteredTableDetails.every(
    row => rowSelections[row.IntelliLabDetailsID]?.selected
  );

  let updated = {};
  filteredTableDetails.forEach(row => {
    const id = row.IntelliLabDetailsID;
    updated[id] = {
      ...rowSelections[id],
      selected: !allSelected,
      cpt1: rowSelections[id]?.cpt1 || false,
      cpt2: rowSelections[id]?.cpt2 || false,
    };
  });
  setRowSelections(updated);
};

const resetSelections = () => {
  setRowSelections({});
};

const GenerateNewLabClaims = async () => {
  let hasError = false;
  let firstErrorFocused = false;
  if (!selectedBillingNPI || selectedBillingNPI <= 0) {
    setLocationNPIError('Select location NPI.');
    hasError = true;
    if (!firstErrorFocused) {
      locationNPIRef.current?.focus();
      firstErrorFocused = true;
    }
  } else {
    setLocationNPIError('');
  }

  if (!selectedCMS33a || selectedCMS33a <= 0) {
    setProviderNPIError('Select provider NPI.');
    hasError = true;
    if (!firstErrorFocused) {
      providerNPIRef.current?.focus();
      firstErrorFocused = true;
    }
  } else {
    setProviderNPIError('');
  }

  if (selectedCMS33b === '0') {
    setTaxonomyCodeError('Select taxonomy code.');
    hasError = true;
    if (!firstErrorFocused) {
      taxonomyRef.current?.focus();
      firstErrorFocused = true;
    }
  } else {
    setTaxonomyCodeError('');
  }

  if (isLocChecked) {
    if (!selectedLocations2) {
      setLocationError("Please select a Place of Service.");
      hasError = true;
      if (!firstErrorFocused) {
        locationRef.current?.focus();
        firstErrorFocused = true;
      }
    } else {
      setLocationError("");
    }
  } else {
    setLocationError("");
  }

  if (hasError) {
    setShowSelectErrorModal(false);
    return;
  }

  const anySelected = Object.values(rowSelections).some((r) => r.selected);

  if (!anySelected) {
    setShowSelectErrorModal(true);
    setShowSuccessModal(false);
    return;
  }

  setShowSelectErrorModal(false);
  setLoading(true);

  let ClaimArray = [];

  for (const id in rowSelections) {
    const sel = rowSelections[id];
    if (!sel.selected) continue;

    const item = getRowByID(id);
    if (!item) continue;

    const ICDCode = item.ICDCodes || "";
    let ClaimLineItems = [];

    if (sel.cpt1) {
      ClaimLineItems.push({
        CPTcode: item.CPTCode1 || "",
        Modifier: selectedModifier,
        ICD1: ICDCode,
        CPTServiceID: 1,
      });
    }

    if (sel.cpt2) {
      ClaimLineItems.push({
        CPTcode: item.CPTCode2 || "",
        Modifier: selectedModifier,
        ICD1: ICDCode,
        CPTServiceID: 1,
      });
    }

    const claimDetails = {
      PracticeID: userPracticeID,
      PatientID: item.PatientID,
      DOS: formatDOSDate(item.Appointment_Date),
      ProviderID: item.ProviderID || 0,
      SupervisorIndicator: selectedProvidersCategory,
      SupervisorProviderID: selectedFilterProvider,
      SkipBox32: omitboxRows[id] ?? 0,
      Insurance: selectedInsurances[id],
      PolicyNumber: policyNumbers[id],
      Claim24B: selectedServiceLocation,
      SchedulingProviderID: item.ProviderID || 0,
      Claim32A: selectedBillingNPI,
      Claim33A: selectedCMS33a,
      Claim33B: selectedCMS33b,
      PlaceofService: isLocChecked
        ? selectedLocations2
        : item.MasterPatientLocationID || "",
      UserID: userData.userID,
      RoleID: userData.roleID,
      OrderType: item.OrderType,
      IsClaimSplit: 0,
      IsScheduleAppointment: 0,
      PageModule: "Labbilling",
      PatientSecInsurance: 0,
      PatientSecInsurancePolicy: 0,
      ClaimENote: 0,
      IsPrimarySkipped: 0,
      objCPTDetails: ClaimLineItems,
    };

    ClaimArray.push(claimDetails);
  }

  const inputJson = JSON.stringify(JSON.stringify({ objClaim: ClaimArray }));

  try {
    const response = await fetch(
      APIConstants.BASE_URL_BILLING + LabBillingConstants.GenerateLabClaims,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${sAuthToken}`,
        },
        body: inputJson,
      }
    );

    const responseData = await response.json();

    if (responseData > 0) {
      setTimeout(() => {
        setLoading(false);
        setUpdatedTableData(responseData);
        handleTableDataClick();
      }, 10);

      setShowSuccessModal(true);
      setShowSelectErrorModal(false);
      setSavedRowCount(
        Object.values(rowSelections).filter((r) => r.selected).length
      );
      setRowSelections({});
    } else {
      console.error("Error sending data to the API");
      setLoading(false);
    }
  } catch (error) {
    console.error("An error occurred:", error);
    setLoading(false);
  }
};








  //Checkeligibility functionality


  // const handleCheckeligibility = async (e, rowIndex) => {


  //   const selectedDataArray = [];

  //   for (const rowIndex of insuranceAllCheckbox) {
  //     const item = tableInsDetails[rowIndex] || tableDetails[rowIndex];


  //     const eligibilityDOS = tableDetails[rowIndex].DOS;

  //     var InsCountryId = item.InsCountryId
  //     if (InsCountryId == null) {
  //       InsCountryId = ""
  //     }


  //     var inputStruct = {


  //       "PayerID": item.Id,
  //       "sIns_PolicyNumber": item.PolicyNumber + "",
  //       "patientID": item.PatientId,
  //       "sInsuredFName": item.InsurerFirstname,
  //       "sInsuredLName": item.InsurerLastName,
  //       "sInsuredStateName": item.InsuredStateName + "",
  //       "sInsuredDOB": item.InsurerDOB + "",
  //       "sInsCoID": InsCountryId,
  //       "EligibilityDOS": eligibilityDOS + "",
  //       "EligibilityRowIndex": rowIndex,
  //       "LoggedInUserDetails": userData



  //     };
  //   }
  //   var myInput = { sInputJSON: JSON.stringify(inputStruct) };

  //   myInput = JSON.stringify(myInput);


  //   try {


  //     const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.CheckPatientEligibility, {
  //       method: 'POST',


  //       headers: {

  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'

  //       },

  //       body: myInput
  //     })


  //     if (response.ok) {
  //       const responseData = await response.json();


  //       const parsedData = JSON.parse(responseData.d);


  //       setCheckEligibility(parsedData)



  //       setSavedRowCount(selectedInsRows.length);

  //     } else {
  //       console.error('Error sending data to the API');
  //       setSavedRowCount(savedRowCount + selectedInsRows.length);

  //     }


  //     setSelectedInsRows([]);




  //   } catch (error) {
  //     console.error('An error occurred:', error);

  //   }
  //   setShowIcon(false)
  // }




  const handleDelete = () => {

    const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

    setTableDetails(updatedRows);

    setShowDeleteModal(false)
    setDeleteSuccessModal(true)
    setSelectedRows([]);
    setDeleteRowCount(selectedRows.length);
  };




  // const handleSavedRows = async (e, isSaveforApproval) => {


  //   const ClaimLineItems = [];


  //   for (const rowIndex of selectedRows) {
  //     const item = tableDetails[rowIndex];

  //     var cpt = item?.CPT_Code || "";
  //     var diag1 = item?.ICDCode || "";
  //     var diag2 = item?.ICDCode2 || "";
  //     var diag3 = item?.ICDCode3 || "";
  //     var diag4 = item?.ICDCode4 || "";
  //     var mod2 = item?.Mod2 || "";
  //     var mod1 = item?.Mod1 || "";
  //     var mod3 = item?.Mod3 || "";
  //     var procedure = item?.procedure || "";
  //     var unit = item?.Unit || "";
  //     var unitcharge = item?.Unitcharge || "";
  //     var DOS = item?.DOS || "";
  //     var providerID = item?.ProviderId || "";

  //     // var patientID = item?.patientID|| "";
  //     var ServiceLocationCode = item?.ServiceLocationCode || "";

  //     const selectedData = {

  //       "CPTcode": cpt,
  //       "Diag1": diag1,
  //       "Diag2": diag2,
  //       "Diag3": diag3,
  //       "Diag4": diag4,
  //       "Mod1": mod1,
  //       "Mod2": mod2,
  //       "Mod3": mod3,
  //       "Units": unit,
  //       "Unitcharge": unitcharge,


  //     }



  //     ClaimLineItems.push(selectedData)



  //     const objClaimAllDetails = {

  //       "Dos": DOS,
  //       "ProviderID": providerID,
  //       "ServiceLocAdd": selectedLocation + "",
  //       "sBox17Indicator": selectedProvidersCategory + "",
  //       "PatientID": selectedPatientID + "",
  //       "ServiceLocationCode": 81,
  //       "s32a": selectedBillingNPI + "",
  //       "s33a": selectedCMS33a + "",
  //       "s33b": selectedCMS33b + "",
  //       "PracticeID": userPracticeID,


  //     }


  //     var inputStruct = {

  //       "objClaimAllDetails": objClaimAllDetails,
  //       "objclaimLineitemDetails": ClaimLineItems,
  //       "LoggedInUserDetails": userData


  //     };

  //   }

  //   // var addClaims = JSON.stringify(inputStruct) 
  //   var myInput = { sInputJSON: JSON.stringify(inputStruct) };
  //   var myInputData = JSON.stringify(myInput);
  //   console.log("input of " + IntelliBillConstants.GetIntelliAddNewClaim, myInputData);

  //   try {


  //     const response = await fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliAddNewClaim, {
  //       method: 'POST',


  //       headers: {

  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'

  //       },

  //       body: myInputData
  //     })


  //     if (response.ok) {
  //       const responseData = await response.json();


  //       const parsedData = JSON.parse(responseData.d);

  //       setUpdatedTableData(parsedData)


  //       setFilteredTableDetails((prevRows) => [...prevRows, ...rows]);

  //       handleTableDataClick()
  //       setShowFaxModal(false);

  //       setSavedRowCount(selectedRows.length);

  //     } else {
  //       console.error('Error sending data to the API');
  //       setSavedRowCount(savedRowCount + selectedRows.length);

  //     }


  //     setSelectedRows([]);


  //   } catch (error) {
  //     console.error('An error occurred:', error);

  //   }

  // }






  useEffect(() => {
    const filteredData = tableDetails.filter(item => {
      const toLower = val => (typeof val === 'string' ? val.toLowerCase() : '');

      const locationMatches = searchByLocation
        ? (item.LocationNickname?.toLowerCase() || '').includes(searchByLocation.toLowerCase())
        : true;


      const appointmentDateMatches = searchByDOS
        ? formatDOSDate(item.Appointment_Date)?.toLowerCase().includes(searchByDOS.toLowerCase())
        : true;

      const patientMatches = searchByPatient
        ? (
          (item.FirstName?.toLowerCase() || '').includes(searchByPatient.toLowerCase()) ||
          (item.LastName?.toLowerCase() || '').includes(searchByPatient.toLowerCase())
        )
        : true;


      const dobMatches = searchByDOB
        ? item.DOB?.toLowerCase().includes(searchByDOB.toLowerCase())
        : true;


      const providerMatches = searchByProvider
        ? item.ProviderName?.toLowerCase().includes(searchByProvider.toLowerCase())
        : true;


      const cpt1Status = item.CPTCode1
        ? `${item.CPTCode1} ${item.ScrClaimStatus?.split('$')[1] || 'N'}`
        : '';

      const cptMatches = searchByCPT
        ? toLower(cpt1Status).includes(searchByCPT.toLowerCase())
        : true;


      const cpt2Status = item.CPTCode2
        ? `${item.CPTCode2} ${item.CNFClaimStatus?.split('$')[1] || 'N'}`
        : '';

      const cpt2Matches = searchByCPT2
        ? toLower(cpt2Status).includes(searchByCPT2.toLowerCase())
        : true;


      const codesMatches = searchByCodes
        ? item.OrderCodes?.toLowerCase().includes(searchByCodes.toLowerCase())
        : true;

      const icdMatches = searchByICD1
        ? item.ICDCodes?.toLowerCase().includes(searchByICD1.toLowerCase())
        : true;

      const caseIDMatches = searchByCaseID
        ? item.RequisitionNumber?.toLowerCase().includes(searchByCaseID.toLowerCase())
        : true;

      return (
        locationMatches &&
        appointmentDateMatches &&
        patientMatches &&
        dobMatches &&
        cpt2Matches &&
        providerMatches &&
        cptMatches &&
        codesMatches &&
        icdMatches &&
        caseIDMatches
      );
    });

    setFilteredTableDetails(filteredData);

  }, [searchByLocation, searchByDOS, searchByPatient, searchByDOB, searchByProvider, searchByCPT, searchByCPT2, searchByCodes,
    searchByICD1, searchByCaseID, tableDetails]);













  // const handleSave = () => {

  //   setFilteredTableDetails((prevRows) => [...prevRows, ...rows]);


  //   setRows([]);

  //   setShowFaxModal(false);
  // };






  const handleChangeModifier = (e) => {
    const value = e.target.value;
    setselectedModifier(value);
  };









  const handleSortByDos = () => {

    const sortedTableDetails = [...filteredTableDetails].sort((a, b) => {
      const dateA = new Date(a.DOS);
      const dateB = new Date(b.DOS);

      if (sortDosDate === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    // Toggle sorting order for the next click
    setSortDosDate(sortDosDate === 'asc' ? 'desc' : 'asc');

    // Update table details with sorted data
    setFilteredTableDetails(sortedTableDetails);

  };





  const handleSort = () => {
    const newSortOrder = sortingOrder === 'asc' ? 'desc' : 'asc';
    setSortingOrder(newSortOrder);

    // Sort tableData array based on LastName and FirstName
    const sortedData = filteredTableDetails.sort((a, b) => {
      const nameA = `${a.LastName}, ${a.FirstName}`.toUpperCase();
      const nameB = `${b.LastName}, ${b.FirstName}`.toUpperCase();

      if (newSortOrder === 'asc') {
        return nameA.localeCompare(nameB);
      } else {
        return nameB.localeCompare(nameA);
      }
    });

    // Update state with sorted data
    setTableData([...sortedData]);
  };



  const sortTableByDOB = () => {

    const sortedTableDetails = [...filteredTableDetails].sort((a, b) => {
      const dateA = new Date(a.DOB);
      const dateB = new Date(b.DOB);

      if (sortDateOrder === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    // Toggle sorting order for the next click
    setSortDateOrder(sortDateOrder === 'asc' ? 'desc' : 'asc');

    // Update table details with sorted data
    setFilteredTableDetails(sortedTableDetails);

  };



  const handleSortByInsurance = () => {

    setSortByInsurance(!sortByInsurance);

    if (sortByInsurance) {
      const sortedData = [...filteredTableDetails].sort((a, b) => b.PatInsName.localeCompare(a.PatInsName));
      setSortedInsData(sortedData);
      setFilteredTableDetails(sortedData);
    } else {
      const sortedData = [...filteredTableDetails].sort((a, b) => a.PatInsName.localeCompare(b.PatInsName));
      setSortedInsData(sortedData);
      setFilteredTableDetails(sortedData);
    }
  }


  const handleSortByPolicyNumber = () => {
    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (sortPolicyNumber === 'asc') {
        return a.InsPloicyNo.localeCompare(b.InsPloicyNo);
      } else {
        return b.InsPloicyNo.localeCompare(a.InsPloicyNo);
      }
    });
    setFilteredTableDetails(sortedData);
    setSortPolicyNumber(sortPolicyNumber === 'asc' ? 'desc' : 'asc');
  };



  const handleSortByOrderCodes = () => {

    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (sortOrderCodes === 'asc') {
        return a.OrderCodes - b.OrderCodes;
      } else {
        return b.OrderCodes - a.OrderCodes;
      }
    });
    setFilteredTableDetails(sortedData);


    setSortOrderCodes(sortOrderCodes === 'asc' ? 'desc' : 'asc');
  };


  const handlesortByCPTCode1 = () => {
    const sorted = [...filteredTableDetails].sort((a, b) => {
      if (sortCPTCode1 === 'asc') {
        return a.CPTCode1 - b.CPTCode1;
      } else {
        return b.CPTCode1 - a.CPTCode1;
      }
    });
    setFilteredTableDetails(sorted);
    setSortCPTCode1(sortCPTCode1 === 'asc' ? 'desc' : 'asc');
  };


  const handlesortByCPTCode2 = () => {
    const sorted = [...filteredTableDetails].sort((a, b) => {
      if (sortCPTCode2 === 'asc') {
        return a.CPTCode2 - b.CPTCode2;
      } else {
        return b.CPTCode2 - a.CPTCode2;
      }
    });
    setFilteredTableDetails(sorted);
    setSortCPTCode2(sortCPTCode2 === 'asc' ? 'desc' : 'asc');
  };



  const handleSortByICDCode = () => {
    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (sortICDNumber === 'asc') {
        return a.ICDCodes.localeCompare(b.ICDCodes);
      } else {
        return b.ICDCodes.localeCompare(a.ICDCodes);
      }
    });
    setFilteredTableDetails(sortedData);
    setSortICDNumber(sortICDNumber === 'asc' ? 'desc' : 'asc');
  };



  const handleSortByCaseID = () => {
    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (!a.RequisitionNumber && !b.RequisitionNumber) {

        return 0;
      } else if (!a.RequisitionNumber && b.RequisitionNumber) {

        return sortCaseID === 'asc' ? -1 : 1;
      } else if (a.RequisitionNumber && !b.RequisitionNumber) {

        return sortCaseID === 'asc' ? 1 : -1;
      } else {

        if (sortCaseID === 'asc') {
          return a.RequisitionNumber.localeCompare(b.RequisitionNumber);
        } else {
          return b.RequisitionNumber.localeCompare(a.RequisitionNumber);
        }
      }
    });

    setFilteredTableDetails(sortedData);
    setSortCaseID(sortCaseID === 'asc' ? 'desc' : 'asc');
  };









  const handleSortByProviderName = () => {
    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (sortProviderName === 'asc') {
        return a.ProviderName.localeCompare(b.ProviderName);
      } else {
        return b.ProviderName.localeCompare(a.ProviderName);
      }
    });

    setFilteredTableDetails(sortedData);
    setSortProviderName(sortProviderName === 'asc' ? 'desc' : 'asc');
  };





  const GetDowloadFile = async () => {
  setShowDownLoadErrorModal(false);

  const anySelected = Object.values(rowSelections).some((r) => r.selected);

  if (!anySelected) {
    setShowDownLoadErrorModal(true);
    return;
  }

  const FileArray = [];

  for (const id in rowSelections) {
    if (!rowSelections[id].selected) continue;

    const item = getRowByID(id);
    if (!item) continue;

    FileArray.push({
      FileName: item.ReqPDFName || "",
      FilePhyPath: "",
      FileType: item.FileType,
      PatientID: item.PatientID,
    });
  }

  const dataToSend = {
    FileArray,
    PatientName: "Lab REQ",
    PracticeID: userPracticeID,
  };

  const inputJson = JSON.stringify(JSON.stringify(dataToSend));

  try {
    const response = await fetch(
      APIConstants.SERVICES_URL + LabBillingConstants.GenerateDownloadFile,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: inputJson,
      }
    );

    const data = await response.json();

    if (response.ok) {
      setShowDownLoadErrorModal(false);
      window.open(data, "_blank");
    }
  } catch (error) {
    console.error("Download error:", error);
  }
};







  const handlePrint = () => {

    if (!tableRef.current) {
      console.error("Table reference is not set.");
      return;
    }

    setVisibleRecords(filteredTableDetails.length);
    const prevVisibleCount = visibleRecords;

    setTimeout(() => {
      const tableHTML = tableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");

      printWindow.document.writeln(`
        <html>
          <head>
            <title class="print-title">Lab-Billing</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 10px;
                font-size: 15px;
                color: #000;
              }
  
              .print-title {
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 20px;
                color: #0173b7;
              }
  
              .table-container {
                width: 100%;
                overflow-x: auto;
              }
  
              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: auto; 
                word-wrap: break-word;
              }
  
              th, td {
                border: 1px solid black;
                padding: 5px;
                text-align: left;
                font-size: 15px;
              }
  
              th {
                background-color: #f4f4f4;;
                font-size: 15px;
                color: white !important;
                border: 1px solid black;
                text-align: top;
                transform-origin: left bottom;
                height: 120px;
                
              }
              td{
                  font-size:14px
                }
  
              @media print {
                @page {
                  size: A4 landscape;
                  margin: 10mm;
                }
  
                .table-container {
                  overflow: visible !important;
                }
  
                 .hide-on-print {
                  display: none !important;
                }
  
                
                .input{
                  width: 20px !important;
                  color: black;
                  
                }

               
                .show-on-print {
                    width: 30px;
                }

                .print-label {

                   display: inline-block;
                    max-width: 40px; 
                    word-wrap: break-word;
                    white-space: normal !important;
                    overflow-wrap: break-word;
                    font-size: 12px;
                 }
              }
  
              body {
                  -webkit-print-color-adjust: exact;
                }
              }
            </style>
          </head>
          <body>
           
            <div class="table-container">${tableHTML}</div>
            <script>
              window.onload = function() {
                window.print();
              };
              window.onafterprint = function() {
                window.close();
              };
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();
      setTimeout(() => {
        setVisibleRecords(prevVisibleCount);
      }, 10);
    }, 10);
  };




  const tableRef = useRef('');


  const exportToExcel = () => {
    const pagename = 'LabBilling';
    const table = tableRef.current;
    let sPrintableData = table ? table.innerHTML : '';

    const vRegEx = new RegExp("gvClosedClaims", "");
    sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");



    const PrintableDataDetails = {
      PrintableData: sPrintableData,
      PageName: pagename,
    };

    const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
    const InputJSON = JSON.stringify(InputJSONLevelOne);



    fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: InputJSON,
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {


        if (data && data[2]) {

          const url = data[2];
          window.open(url, '_blank');

        }
      })
      .catch(error => {
        console.error('Export to Excel failed', error);
      });
  };





  const exportToPDF = () => {
    const pagename = 'LabBilling';
    const table = tableRef.current.parentNode;
    let sPrintableData = table ? table.innerHTML : '';

    const vRegEx = new RegExp("gvClosedClaims", "");
    sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");



    const PrintableDataDetails = {
      PrintableData: sPrintableData,
      PageName: pagename,
    };

    const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
    const InputJSON = JSON.stringify(InputJSONLevelOne);



    fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: InputJSON,
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {


        if (data && data[2]) {

          const url = data[2];
          window.open(url, '_blank');


        }
      })
      .catch(error => {
        console.error('Export to PDF failed', error);
      });
  };



  // if (!userData) {
  //   return <div>Loading user data...</div>;

  // }


  if (userData) {

    userPracticeID = userData.practiceID;
    LocationId = userData.LocationID;

    localStorage.setItem('userPracticeID', userPracticeID);
  }


  const handleRowClick = (index) => {
    setActiveRow(index);
  };




  const handleDosLinkClick = (item) => {
    const url = `/#/transactionlogs/${item.ClaimId}?state=${encodeURIComponent(JSON.stringify(item))}`;
    window.open(url, '_blank');
  };




  const handlePatLinkClick = (item) => {
    const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

    localStorage.setItem("LabPatientID", item.PatientID);

    window.open(url, '_blank');
  };


  const formatDOSDate = (dateString) => {
    if (!dateString) {
      return "";  // Return empty string if dateString is null or empty
    }

    const date = new Date(dateString);


    if (isNaN(date)) {
      return "";  // Return empty string if the date is invalid
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };






 useEffect(() => {
  const initializeInsuranceData = () => {
    let updatedFilteredTableDetails = [...tableDetails];
    if (searchByPolicy.trim() !== '') {
      const policySearchLower = searchByPolicy.trim().toLowerCase();
      const matchingPatientIDs = tableInsDetails
        .filter(ins => (ins.PolicyNumber || '').toLowerCase().startsWith(policySearchLower))
        .map(ins => ins.PatientID);

      updatedFilteredTableDetails = updatedFilteredTableDetails.filter(item =>
        matchingPatientIDs.includes(item.PatientID)
      );
    }
    if (searchByInsuranceID.trim() !== '') {
      const insuranceSearchLower = searchByInsuranceID.trim().toLowerCase();
      updatedFilteredTableDetails = updatedFilteredTableDetails.filter(item => {
        const matchingInsurance = tableInsDetails.find(ins =>
          ins.PatientID === item.PatientID &&
          new Date(item.Appointment_Date) >= new Date(ins.InsStartDate) &&
          new Date(item.Appointment_Date) <= new Date(ins.InsEndDate)
        );
        return (
          matchingInsurance &&
          (matchingInsurance?.InsCompNickName || '').toLowerCase().startsWith(insuranceSearchLower)
        );
      });
    }
    const initialSelectedInsurances = {};
    const initialPolicyNumbers = {};
    updatedFilteredTableDetails.forEach((item) => {
      const defaultInsurance = tableInsDetails.find(ins =>
        ins.PatientID === item.PatientID &&
        new Date(item.Appointment_Date) >= new Date(ins.InsStartDate) &&
        new Date(item.Appointment_Date) <= new Date(ins.InsEndDate)
      );
      const id = item.IntelliLabDetailsID;
      if (defaultInsurance && defaultInsurance.PrimaryInsID) {
        initialSelectedInsurances[id] = defaultInsurance.PrimaryInsID;
        initialPolicyNumbers[id] = defaultInsurance.PolicyNumber ?? '';
      } else {
        initialSelectedInsurances[id] = '';
        initialPolicyNumbers[id] = '';
      }
    });

    setSelectedInsurances(initialSelectedInsurances);
    setPolicyNumbers(initialPolicyNumbers);
    setFilteredTableDetails(updatedFilteredTableDetails);
  };

  initializeInsuranceData();
}, [tableDetails, tableInsDetails, searchByInsuranceID, searchByPolicy]);





  const handleInsuranceChange = (id, selectedPrimaryInsID) => {
  setSelectedInsurances(prev => ({
    ...prev,
    [id]: selectedPrimaryInsID
  }));
  const item = filteredTableDetails.find(x => x.IntelliLabDetailsID === Number(id));
  if (!item) {
    setPolicyNumbers(prev => ({ ...prev, [id]: '' }));
    return;
  }
  const matchingIns = tableInsDetails.find(ins =>
    ins.PatientID === item.PatientID &&
    ins.PrimaryInsID === selectedPrimaryInsID &&
    new Date(item.Appointment_Date) >= new Date(ins.InsStartDate) &&
    new Date(item.Appointment_Date) <= new Date(ins.InsEndDate)
  );
  setPolicyNumbers(prev => ({
    ...prev,
    [id]: matchingIns?.PolicyNumber ?? ''
  }));
};





  const handleOrderLinkClick = (item) => {
    setShowDataModal(true);
  };





  const handlePDFClick = (e, pdfName) => {
    e.preventDefault(); // Prevent the default link behavior


    const url = pdfName;



    // Open the PDF in a new tab
    window.open(url, '_blank');
  };


  const handlePracticeButtonClick = (item) => {
    setSelectedCMS33a(item.NPI);

    setSelectedBillingNPI(item.NPI);

    const matchedTaxonomy = practiceTaxonomycodes.find(
      (tax) => tax.PracticeLabel === item.PracticeLabel
    );

    if (matchedTaxonomy) {
      setSelectedCMS33b(matchedTaxonomy.Taxonomycode);

    }
  };


  const removeHtmlTags = (htmlString) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText;
  };



  const getClassForClaimStatus = (claimStatusFlag) => {
    const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);

    switch (cleanClaimStatusFlag) {
      case 'N':
        return 'not-submit-style';
      case 'D':
        return 'denied-style';
      case 'P':
        return 'paid-style';
      case 'F':
        return 'forwarded-style';
      case 'R':
        return 'rejected-style';
      default:
        return '';
    }
  };



  const getTitleForClaimStatus = (claimStatusFlag) => {
    const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
    switch (cleanClaimStatusFlag) {
      case 'N':
        return 'Not-Billed';
      case 'D':
        return 'Denied';
      case 'P':
        return 'Paid';
      case 'F':
        return 'Forwarded';
      case 'R':
        return 'Rejected';
      default:
        return '';
    }
  };



  const handleLocCheckboxChange = (e) => {
    setIsLocChecked(e.target.checked);
  };






  return (
    <>



      <div className='main-container'>
        <div className='container-style'>

          <div className='table_style'>


            <div className='intelli-row-style'>

              <div className="datepicker-container mt-1 " style={{ marginLeft: '5px', zIndex: 10 }}>
                <label>From:</label>



                <DatePicker
                  selected={startDate ? new Date(startDate) : null}
                  onChange={handleStartDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                  placeholderText="MM/dd/yyyy"
                  calendarContainer={CalendarStartContainer}
                  open={isStartOpen}
                  onFocus={() => setIsStartOpen(true)}
                  onInputClick={() => setIsStartOpen(true)}
                  onClickOutside={() => setIsStartOpen(false)}
                  renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px', padding: '5px' }}>
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) => changeMonth(Number(value))}
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) => changeYear(Number(value))}
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option key={k} value={new Date().getFullYear() - k}>
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px', padding: '5px' }}>
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />



              </div>



              <div className="datepicker-container mt-1" style={{ marginLeft: '5px', zIndex: 10 }}>
                <label>To:</label>
                <DatePicker
                  selected={endDate ? new Date(endDate) : null}
                  onChange={handleEndDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                  placeholderText="MM/dd/yyyy"
                  popperPlacement="bottom-start"
                  readOnly={isHideChecked}
                  calendarContainer={CalendarContainer}
                  open={isEndOpen}
                  onFocus={() => setIsEndOpen(true)}
                  onInputClick={() => setIsEndOpen(true)}
                  onClickOutside={() => setIsEndOpen(false)}
                  renderCustomHeader={({
                    date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) => changeMonth(Number(value))}
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) => changeYear(Number(value))}
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option key={k} value={new Date().getFullYear() - k}>
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />
              </div>


              <div className='mt-1' style={{ marginLeft: '12px' }}>

                <label>Insurance:</label>

              </div>

              <div style={{ marginLeft: '5px', marginTop: '3px', width: '8%' }}>
                <input
                  type='text'
                  value={searchText}
                  onChange={handleInputChange}
                  onKeyDown={handleInsListKeyDown}
                  style={{ width: '130px' }}
                />
                <div className='autocomplete'>
                  <ul className='list-style' style={{ fontSize: '0.9rem' }}>
                    {suggestions.map((suggestion) => (
                      <li key={suggestion.val} onClick={() => handleInsSuggestionList(suggestion)}>{suggestion.label}</li>
                    ))}
                  </ul>
                </div>

              </div>

              <div style={{ marginLeft: '1px', marginTop: '4px', width: '110px' }}>

                <input
                  style={{ marginLeft: '1px', marginTop: '3px' }}
                  type='checkbox'
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />

                <label style={{ marginLeft: '5px', marginTop: '3px' }}>Checked-in</label>
              </div>



              <div className='mt-1' style={{ marginLeft: '20px', width: '200px' }}>

                <label>Lab:</label>
                <select name="select" id="" className='select-style' value={selectedLabValue} onChange={(e) => setSelectedLabValue(e.target.value)} >

                  {labDropDownData.map((item, index) => (

                    <option key={index} value={item.LabID}>{item.LabName}</option>
                  ))}

                </select>
              </div>



              <div style={{ marginLeft: '1px' }}>


                <select name="select" style={{
                  width: '150px', height: '30px', marginTop: '3px',
                  backgroundColor:
                    selectedLocation !== '-1'
                      ? (locations.find((loc) => loc.LocationId == selectedLocation)?.Color || '#fff')
                      : '#fff'
                }}

                  value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} >

                  <option value="-1" >
                    All
                  </option>

                  {locations.map((item, index) => (

                    <option key={index} value={item.LocationId} style={{ backgroundColor: item.Color }}>{item.LocationName}</option>
                  ))}
                </select>

              </div>


              <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                <FontAwesomeIcon style={{ fontSize: '1.5rem', cursor: 'pointer' }} onClick={(e) => handleTableDataClick(e)} icon={faMagnifyingGlass} />
              </div>

              <div className='d-flex mt-2' style={{ marginLeft: '20px' }}>
                <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: '1.5rem' }} onClick={handlePrint} icon={faPrint} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToExcel} icon={faFileExcel} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToPDF} icon={faFilePdf} />


              </div>


              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 20px',
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
                width: 'fit-content',
                marginTop: '5px',
                fontSize: '1.2rem',
                marginLeft: '50px',
                height: '30px'
              }}>
                <span style={{ fontWeight: '600', color: '#333' }}>Total Records:</span>
                <span style={{ fontWeight: '700', color: '#007bff' }}>{filteredTableDetails.length}</span>
              </div>


            </div>
          </div>

          <div className='table-primary row-style'>

            <div className='intelli-row-style' >
              <div className='d-flex input-style2'>




                <div style={{ marginLeft: '1px', width: '170px', marginTop: '5px' }}>


                  <select name="select" style={{ width: '130px', height: '30px' }}
                    value={selectedProvidersCategory} onChange={(e) => setSelectedProvidersCategory(e.target.value)}>
                    {providerCategory.map((item, index) => (
                      <option value={item.Value}>{item.Label}</option>
                    ))}

                  </select>(17)

                  <div className='mt-2'>
                    <select name="select" style={{ width: '130px', height: '30px' }}
                      onChange={handleSelectFilterProviders} value={selectedFilterProvider}>
                      <option value="" >
                        &lt;--Select--&gt;
                      </option>

                      {filteredProviders.map(provider => (

                        <option key={provider.providerID} value={provider.providerID}>{provider.providerName}</option>

                      ))}
                    </select>
                  </div>
                </div>





                <div >
                  <label style={{ width: '150px', marginTop: '8px', marginLeft: '1px' }}>Service Loc(24 B)</label>
                  <br />
                  <select name="select" style={{ color: 'black', marginLeft: '0px', width: '120px', height: '30px' }}
                    value={selectedServiceLocation}
                    onChange={(e) => handleSelectChange(e)}

                  >
                    {ServiceLocations.map((item, index) => (

                      <option key={index} style={{ color: 'black' }} value={item.ValueField}>{item.TextField}</option>
                    ))}
                  </select>




                </div>

              </div>



              {/* <div className='vl' style={{ marginLeft: '310px' }}></div>
              <div className='vl' style={{ marginLeft: '700px' }}></div> */}






              <div style={{ display: "flex", marginTop: '20px' }}>
                <div style={{ display: "flex", marginLeft: '10px', marginTop: '0px', justifyContent: 'space-between', width: 'auto', gap: '5px' }}>
                  {BillingNPIs.map((item, index) => (
                    <div key={index}>
                      {item.PracticeLabel && (
                        <button
                          className="but"
                          onClick={() =>
                            handlePracticeButtonClick(item)
                          }
                          value={`Selected ${item.PracticeLabel}`}
                        >
                          {item.PracticeLabel}
                        </button>
                      )}



                    </div>
                  ))}
                </div>



              </div>



              <div style={{ marginLeft: '20px', marginTop: '2px' }}>


                <label style={{ width: '220px' }}>Service Facility:(32)
                  <span style={{ color: 'Red' }}>*</span>
                  <span style={{ marginLeft: '10px' }}>
                    <input type='checkbox'
                      checked={isLocChecked}
                      onChange={handleLocCheckboxChange}
                    />
                  </span>
                </label>


                <br />
                <select name="select" ref={locationRef} className={`select-input1  ${selectedLocations2 === '-1' ? 'red-bg' : 'green-bg'}`}
                  value={selectedLocations2} onChange={handleLocationChange}>
                  <option value="-1" >
                    &lt;--Select--&gt;
                  </option>
                  {locations2.map((item, index) => (
                    <option style={{ width: "100px" }} value={item.LocationId} key={index}  >{item.LocationName}</option>

                  ))}
                </select>
                {selectedLocations2 <= 0 && (
                  <div style={{ position: 'absolute', marginLeft: '1px' }}>
                    <label style={{ fontSize: '0.9rem', color: 'red' }}>{locationError}</label>
                  </div>
                )}

              </div>



              <div style={{ marginLeft: '20px', marginTop: '2px' }}>

                <label style={{ width: '220px' }}>Service Location NPI:(32 a)
                  <span style={{ color: 'Red' }}>*</span>
                </label>
                <br />
                <select name="select" ref={locationNPIRef} className={`select-input1 ${selectedBillingNPI === '0' ? 'red-bg' : 'green-bg'}`}
                  value={selectedBillingNPI} onChange={handleSelectBillingNPI}>
                  {BillingNPIs.map((item, index) => (
                    <option value={item.NPI} key={index}>{item.namewithNPI}</option>

                  ))}
                </select>

                <br />
                {selectedBillingNPI <= 0 && (
                  <div style={{ position: 'absolute', marginLeft: '0px', marginTop: '1px' }}>
                    <label style={{ fontSize: '0.9rem', color: 'red' }}>{locationNPIError}</label>
                  </div>
                )}
              </div>





              <div style={{ marginLeft: '10px' }}>
                <label style={{ width: '220px', marginLeft: '1px', marginTop: '2px' }}>Billing Provider NPI: (33 a)
                  <span style={{ color: 'Red' }}>*</span>
                </label>

                <br />

                <select name="select" ref={providerNPIRef} className={`select-input ${selectedCMS33a === '0' ? 'red-bg' : 'green-bg'}`}
                  value={selectedCMS33a} onChange={(e) => setSelectedCMS33a(e.target.value)}>
                  {cms33aData.map((item, index) => (
                    <option key={index} value={item.NPI}>{item.namewithNPI}</option>

                  ))}
                </select>
                <br />
                {selectedCMS33a <= 0 && (
                  <div style={{ position: 'absolute', marginLeft: '30px', marginTop: '0px' }}>
                    <label style={{ fontSize: '0.9rem', color: 'red' }}>{providerNPIError}</label>
                  </div>
                )}
              </div>




              <div className='input-style3'>

                <label style={{ width: '300px' }}>Billing Provider Taxonomy code:(33 b)
                  <span style={{ color: 'Red' }}>*</span>
                </label>

                <br />
                <select name="select" ref={taxonomyRef} className={`select-input ${selectedCMS33b === '0' ? 'red-bg' : 'green-bg'}`}
                  value={selectedCMS33b} onChange={(e) => setSelectedCMS33b(e.target.value)}>
                  {cms33bData.map((item, index) => (
                    <option style={{ width: "100px" }} key={index} value={item.taxonomycode}>
                      {item.namewithtaxcode}
                    </option>
                  ))}

                </select>

                {selectedCMS33b === '0' && (
                  <div style={{ position: 'absolute', marginLeft: '0px', marginTop: '0px' }}>
                    <label style={{ fontSize: '0.9rem', color: 'red' }}>{taxonomyCodeError}</label>
                  </div>
                )}
              </div>




              <div style={{ marginLeft: '20px', marginTop: '1px', fontFamily: 'serif', fontSize: '1.1rem' }}>
                <label>Modifier</label>
                <br />
                <input type='text' style={{ marginLeft: '1px', width: '150px', backgroundColor: 'yellow', borderColor: 'lightgray' }}
                  value={selectedModifier}
                  onChange={handleChangeModifier}
                />
              </div>



              <div className=' mt-4' style={{ marginLeft: '20px' }} >


                <button className='btn-style2' onClick={GenerateNewLabClaims}>Generate Claim</button>
                <button className='btn-style3' style={{ marginLeft: '10px' }} onClick={GetDowloadFile}>Download</button>
              </div>



            </div>







            {loading && (
              <div className="overlay">
                <div className="spinner-container">
                  <div className="spinner-grow text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="spinner-grow text-warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="spinner-grow text-info" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            )}

          </div>


          <div className="table-container mt-1 ">
            <table className="main_table fixed-header table-info table table-hover table-striped table-bordered border-secondary border-white" ref={tableRef}>

              <thead>

                <tr className='align-top' >

                  <th className='border-white col-sm col-th  text-white' style={{ backgroundColor: '#0173b7', width: '30px' }}>#</th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }} >Location
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByLocation}
                      onChange={(e) => setSearchByLocation(e.target.value)}
                    />
                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByDos}>DOS</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByDOS}
                      onChange={(e) => setSearchByDOS(e.target.value)}
                    />
                  </th>
                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSort}>Patient Name</Link>

                    <br />
                    <input style={{ width: '110px', height: '30px', borderRadius: '5px' }}
                      type='text'
                      placeholder='Search'
                      value={searchByPatient}
                      onChange={(e) => setSearchByPatient(e.target.value)}
                    />

                  </th>

                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={sortTableByDOB}>DOB</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      type='text'
                      placeholder='Search'
                      value={searchByDOB}
                      onChange={(e) => setSearchByDOB(e.target.value)}
                    />
                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByInsurance}>Insurance</Link>
                    <br />




                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByInsuranceID}
                      onChange={(e) => setSearchByInsuranceID(e.target.value)}
                    />

                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByPolicyNumber}>Policy Number</Link>
                    <br />
                    <input style={{ width: '120px', height: '30px', borderRadius: '5px', }} type='text' placeholder='Search'
                      value={searchByPolicy}
                      onChange={(e) => setSearchByPolicy(e.target.value)}
                    />

                  </th>

                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByOrderCodes}>Order Code</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByCodes}
                      onChange={(e) => setSearchByCodes(e.target.value)}
                    />


                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handlesortByCPTCode1}>CPT Code</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByCPT}
                      onChange={(e) => setSearchByCPT(e.target.value)}
                    />
<input
  type="checkbox"
  checked={
    filteredTableDetails.length > 0 &&
    filteredTableDetails.every(
      row => rowSelections[row.IntelliLabDetailsID]?.cpt1
    )
  }
  onChange={handleSelectAllCPT1}
/>

                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handlesortByCPTCode2}>CPT Code</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByCPT2}
                      onChange={(e) => setSearchByCPT2(e.target.value)}
                    />
<input
  type="checkbox"
  checked={
    filteredTableDetails.length > 0 &&
    filteredTableDetails.every(
      row => rowSelections[row.IntelliLabDetailsID]?.cpt2
    )
  }
  onChange={handleSelectAllCPT2}
/>

                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByICDCode}>ICD</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByICD1}
                      onChange={(e) => setSearchByICD1(e.target.value)}
                    />

                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByCaseID}>Case ID</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByCaseID}
                      onChange={(e) => setSearchByCaseID(e.target.value)}
                    />

                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>Omit Box 32
                    <br />
                   <input
  type="checkbox"
  checked={
    filteredTableDetails.length > 0 &&
    filteredTableDetails.every(
      (item) => omitboxRows[item.IntelliLabDetailsID] === 1
    )
  }
  onChange={handleSelectOmitBOXAllChange}
/>
                  </th>

                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByProviderName}>Rendering provider</Link>
                    <br />
                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByProvider}
                      onChange={(e) => setSearchByProvider(e.target.value)}
                    />

                  </th>


                  <th className='border-white col col-th-style  text-white hide-on-print' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }}>Requisition</Link>
<input
  type="checkbox"
  checked={
    filteredTableDetails.length > 0 &&
    filteredTableDetails.every(
      row => rowSelections[row.IntelliLabDetailsID]?.selected
    )
  }
  onChange={handleSelectAllRows}
/>
                  </th>

                  <th className='border-white col col-th-style  text-white hide-on-print' style={{ backgroundColor: '#0173b7', width: '100px' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }}>Result</Link>

                  </th>

                </tr>

              </thead>

              <tbody>



                {filteredTableDetails.length > 0 ? (
                  filteredTableDetails.slice(0, visibleRecords).map((item, index) => {


                    const insDetails = tableInsDetails.filter(ins => ins.PatientID === item.PatientID);




                    const filteredInsDetails = insDetails.filter(ins =>

                      filteredTableDetails.some(item =>
                        new Date(item.Appointment_Date) >= new Date(ins.InsStartDate) &&

                        new Date(item.Appointment_Date) <= new Date(ins.InsEndDate))


                    );


                    return (
                      <tr className={`  ${activeRow === index ? 'table-warning' : ''} `}


                        key={index}
                        onClick={() => handleRowClick(index)}

                        style={{
                          backgroundColor: index % 2 === 1 ? 'lightblue' : 'inherit',
                        }}


                      >

                        <td className='border-white ' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                        <td className='border-white ' style={{ width: '120px' }}><label>{item.LocationNickname}</label></td>
                        <td className='border-white ' style={{ width: '120px' }}>

                          <label className='linkspan' onClick={() => handleDosLinkClick(item)}>

                            {formatDOSDate(item.Appointment_Date)}
                          </label>

                        </td>


                        <td className='border-white '>
                          <label className='linkspan' onClick={() => handlePatLinkClick(item)}>
                            {item.LastName},{item.FirstName}
                          </label>
                        </td>

                        <td className='border-white ' style={{ width: '120px' }}><label className='label-style'>{formatDOSDate(item.DOB)}</label></td>
                       <td className='border-white '>
  {(() => {
    const options = getFilteredInsDetailsForItem(item);
    const id = item.IntelliLabDetailsID;
    return options.length > 0 ? (
      <select
        name="select"
        style={{ width: '130px' }}
        value={selectedInsurances[id] || ''}
        onChange={(e) => handleInsuranceChange(id, e.target.value)}
      >
        <option value=''>Select</option>
        {options.map((ins, i) => (
          <option key={i} value={ins.PrimaryInsID || ''}>
            {ins.InsCompNickName || ''}
          </option>
        ))}
      </select>
    ) : (
      <select name="select" style={{ width: '130px' }} value=''>
        <option value=''>No Insurance</option>
      </select>
    );
  })()}
</td>

<td className='border-white '>
  <label className='label-style'>
    { policyNumbers[item.IntelliLabDetailsID] || '' }
  </label>
</td>


                        <td className='border-white '><label className='label-style' onClick={handleOrderLinkClick}><Link>{item.OrderCodes}</Link></label>

                        </td>

                        <td className='border-white '><label>{item.CPTCode1}</label>






                          {item.CPTCode1 !== "" && item.CPTCode1 !== null && (item.ScrClaimStatus === null ? (

                            <>

                              <label
                                className={getClassForClaimStatus('N')}
                                title={getTitleForClaimStatus('N')}>N
                              </label>


                              <input
  type="checkbox"
  checked={!!rowSelections[item.IntelliLabDetailsID]?.cpt1}
  onChange={() => toggleCPT1(item.IntelliLabDetailsID)}
/>

                            </>

                          ) : (
                            <>



                              {
                                item.ScrClaimStatus.split('$')[1] === "" ? (
                                  <>

                                  </>
                                ) : (
                                  <>

                                    <label
                                      className={getClassForClaimStatus(item.ScrClaimStatus.split('$')[1])}
                                      title={getTitleForClaimStatus(item.ScrClaimStatus.split('$')[1])}>{removeHtmlTags(item.ScrClaimStatus.split('$')[1])}
                                    </label>

                                  </>
                                )
                              }

                            </>
                          ))
                          }



                        </td>


                        <td className='border-white '><label>{item.CPTCode2}</label>



                          {item.CPTCode2 !== "" && item.CPTCode2 !== null && (item.CNFClaimStatus === null ? (

                            <>

                              <label
                                className={getClassForClaimStatus('N')}
                                title={getTitleForClaimStatus('N')}>N
                              </label>

                              <input
  type="checkbox"
  checked={!!rowSelections[item.IntelliLabDetailsID]?.cpt2}
  onChange={() => toggleCPT2(item.IntelliLabDetailsID)}
/>

                            </>

                          ) : (
                            <>




                              {
                                item.CNFClaimStatus.split('$')[1] === "" ? (
                                  <>

                                  </>
                                ) : (
                                  <>

                                    <label
                                      className={getClassForClaimStatus(item.CNFClaimStatus.split('$')[1])}
                                      title={getTitleForClaimStatus(item.CNFClaimStatus.split('$')[1])}>{removeHtmlTags(item.CNFClaimStatus.split('$')[1])}
                                    </label>

                                  </>
                                )
                              }

                            </>
                          ))
                          }




                        </td>

                        <td className='border-white '><label>{item.ICDCodes}</label>

                        </td>
                        <td className='border-white '><label>{item.RequisitionNumber}</label>

                        </td>
                        <td className='border-white ' style={{ width: '120px' }}>
                 <input
  type="checkbox"
  checked={omitboxRows[item.IntelliLabDetailsID] === 1}
  onChange={() => handleOmitBoxRowCheckboxChange(item.IntelliLabDetailsID)}
/>
                        </td>

                        <td className='border-white '>
                          <label>{item.ProviderName}</label>
                        </td>
                        <td className='border-white hide-on-print' style={{ width: '120px' }}>
                          <div style={{ display: 'flex' }}>
                            {item.IsOrderSubmitted === 1 && (
                              <a
                                href="#"
                                onClick={(e) => handlePDFClick(e, item.ReqPDFURL)}
                                style={{ cursor: 'pointer', color: 'black' }}
                              >
                                <FontAwesomeIcon icon={faFileLines} />
                              </a>
                            )}

                            <div style={{ justifyContent: 'right' }}>
                          <input
  type="checkbox"
  checked={!!rowSelections[item.IntelliLabDetailsID]?.selected}
  onChange={() => toggleRow(item.IntelliLabDetailsID)}
/>
                            </div>
                          </div>

                        </td>





                        <td className='border-white hide-on-print' style={{ width: '100px' }}>

                          {item.ResultPDFName && item.ResultPDFName !== '' && (

                            <>
                              <FontAwesomeIcon icon={faCircleCheck} className='success-icon hide-on-print' />
                              <a
                                href="#"
                                onClick={(e) => handlePDFClick(e, item.ResPDFURL)}
                                style={{ cursor: 'pointer' }}
                              >
                                <FontAwesomeIcon className='hide-on-print'
                                  style={{ marginLeft: '8px', color: 'red' }}
                                  onClick={exportToPDF}
                                  icon={faFilePdf}
                                />
                              </a>
                            </>
                          )}


                        </td>

                        <input type='hidden' value={item.PatientId} />
                        <input type='hidden' value={item.procedure} />
                        <input type='hidden' value={item.CPTRowID} />
                        <input type='hidden' value={item.providerid} />
                        <input type='hidden' value={item.ServiceLocationCode} />
                        <input type='hidden' value={item.PrimaryIns} />
                        <input type='hidden' value={item.DataValidationMessage} />


                      </tr>



                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="16" style={{ textAlign: "center" }}>No records found</td>
                  </tr>

                )}







              </tbody>





              <div className='btn-container2' style={{ marginLeft: '2000px' }} >


                <button className='btn-style2' onClick={GenerateNewLabClaims}>Generate Claim</button>
                <button className='btn-style3' onClick={GetDowloadFile}>Download</button>
              </div>


              {showSelectErrorModal && (

                <div className='alert-modal'>

                  <p className='mt-3'>Select one or more files to generate claims by selecting the check box!!</p>
                  <button className='btn btn-danger' style={{ width: '50px', height: '30px', padding: '4px' }} onClick={handleCloseModals}>Ok</button>

                </div>

              )}



              {showDownLoadErrorModal && (

                <div className='alert-modal'>

                  <p className='mt-3'>Select one or more files to generate Download by selecting the check box!!</p>
                  <button className='btn btn-danger' style={{ width: '50px', height: '30px', padding: '4px' }} onClick={handleCloseModals}>Ok</button>

                </div>

              )}


              {showSuccessModal && (
                <div className='alertmsg-modal'>
                  <label></label>
                  <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                  <p>{`${savedRowCount}  Claim Generated`}</p>

                </div>
              )}




              {showDeleteModal && (

                <div className='alert-modal'>

                  <p> {`${savedRowCount}  claim successfully Saved`}</p>
                  <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                  <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={handleDelete}>Delete</button>
                </div>
              )}


            </table>



            {showPopup && (
              <div style={{
                position: 'fixed',
                bottom: '50px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#333',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '5px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                zIndex: 1000,
                height: '100px',
                width: '400px',
                textAlign: 'center'
              }}>
                <label style={{ marginTop: '20px', fontSize: '1.4rem' }}>{popupMessage}</label>
              </div>
            )}






            {showDataModal && (

              <Draggable>
                <div className='dialog-box3' >



                  <table className="table table-bordered border-secondary border-white" >

                    <thead>

                      <tr>

                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>

                        <th classNam='topnavsub2'>
                          <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white' }} onClick={handleCloseModals} icon={faXmark} />

                        </th>

                      </tr>



                      <tr>

                        <th className='text-white  border-white' style={{ backgroundColor: '#0173b7', width: '30px', }}>#</th>


                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Analyte

                        </th>


                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7' }} >CPT


                        </th>

                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Unit Charge

                        </th>


                        <th className='col col-th text-white  border-white' style={{ backgroundColor: '#0173b7' }}>Select

                        </th>


                      </tr>



                    </thead>







                    <button className='diagbtn-style mt-5' style={{ marginLeft: '250px' }} onClick={handleCloseModals}>Save</button>



                  </table>

                </div>
              </Draggable>


            )}


          </div>










        </div>


      </div>




    </>
  )
}

export default LabBilling;